import {NAVIGATION} from '../actions/const';

const initialState = {
  showModal: false,
  isLoggingOut: false
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case NAVIGATION:
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/Navigation.js